import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import { doAction } from "@bd-core/bd-hooks";
import { goAsync } from "@bd-utils/goAsync";
import CONFIG from "@bd-core/config";
import Store_GameSession from "@bd-components/store-game-session";

export const LoginPage = () => {
	const isLoginPage = $("body").hasClass("login-page");
	if (!isLoginPage) return false;

	if (Store_GameSession.isValid() && CONFIG.GP) {
		bdjs.showLoading(() => {
			window.location.href = CONFIG.siteURL + bdjs.suffixURL();
		}, true);
		return false;
	}

	const elms = {
		submit: ".js-submit-login",
		inputCode: ".js-input-code",
		inputEmail: ".js-input-email",
		btnSnackBarClose: ".js-close-snackbar",
		codeWrapper: ".loginScreen__form",
	};

	const $snackbar = $(".snackbar");

	const onInputChange = (e) => {
		const isDisabled = String($(e.currentTarget).val()).trim().length < 1;
		$(elms.submit).prop("disabled", isDisabled);
	};

	$(elms.inputEmail).on("input", onInputChange);

	const loginUsingCodeOrGuest = async () => {
		const $loginBtn = $(elms.submit);
		const $inputCode = $(elms.inputCode);
		const $codeWrapper = $(elms.codeWrapper);

		if ($loginBtn.hasClass("is-loading")) return;

		const captcha = typeof grecaptcha !== "undefined" ? grecaptcha : null; // eslint-disable-line no-undef
		const isUsingCaptcha = $('.g-recaptcha').length > 0;

		$loginBtn.addClass("is-loading");
		$snackbar.removeClass("is-active");
		$codeWrapper.removeClass("is-error");

		const request = bdapi.post;
		const { data: response, err } = await goAsync(
			request("public/login", {
				code: $inputCode.val(),
				re_response: isUsingCaptcha ? captcha?.getResponse() : '',
			})
		);

		$snackbar.removeClass("is-error");
		$loginBtn.removeClass("is-loading");

		if(isUsingCaptcha) captcha?.reset();

		const restData = response?.data || {};
		const restMessage =
			restData?.data?.message || "Something went wrong. Please try again!";
		const isCodeInvalid = restData?.data?.invalidCode || false;

		if (isCodeInvalid) $codeWrapper.addClass("is-error");

		if (err || !restData?.success) {
			$snackbar.addClass("is-error");
			$snackbar.find(".snackbar__main__text").html(restMessage);
			$snackbar.addClass("is-active");
			return;
		}

		const gpId = restData?.data?.gp_id;
		const teamCode = restData?.data?.team_code;
		if (gpId && teamCode) {
			Store_GameSession.save(gpId, teamCode);
		}

		bdjs.showLoading(() => {
			const redirect = restData?.data?.redirect || CONFIG.siteURL;
			window.location.href = redirect + bdjs.suffixURL();
		}, true);
	};

	const loginUsingMagicLink = async () => {
		const $btnSubmit = $(elms.submit);
		const $inputEmail = $(elms.inputEmail);

		if ($btnSubmit.hasClass("is-loading")) return;

		const captcha = typeof grecaptcha !== "undefined" ? grecaptcha : null; // eslint-disable-line no-undef

		$btnSubmit.addClass("is-loading");
		$snackbar.removeClass("is-active");

		const request = bdapi.post;
		const { data: response, err } = await goAsync(
			request("public/request-magic-link", {
				email: $inputEmail.val(),
				re_response: captcha?.getResponse(),
			})
		);

		$snackbar.removeClass("is-error");
		$btnSubmit.removeClass("is-loading");

		captcha?.reset();

		const restData = response?.data || {};
		const restMessage =
			restData?.data?.message || "Something went wrong. Please try again!";

		if (err || !restData?.success) $snackbar.addClass("is-error");

		$snackbar.find(".snackbar__main__text").html(restMessage);
		$snackbar.addClass("is-active");
	};

	const goToLogin = function (e) {
		e.preventDefault();

		const loginMode = $(this).attr("data-login-mode");
		let loginUrl = window.location.origin + "/wp-login.php";

		switch (loginMode) {
			case "":
			case "none":
			case "code":
				loginUsingCodeOrGuest();
				break;

			case "sso":
				if (loginUrl.indexOf("?") != -1) {
					loginUrl = loginUrl + "&option=saml_user_login";
				} else {
					loginUrl = loginUrl + "?option=saml_user_login";
				}

				bdjs.redirect(loginUrl);
				break;
			case "magic_link":
				loginUsingMagicLink();
				break;
			default:
				// TODO implement custom login mode mode
				bdjs.redirect(loginUrl);
				break;
		}
	};


	const closeSnackbar = () => $snackbar.removeClass("is-active");

	doAction("login:on-load");

	// $(".login-page").find("#pageWrapper").css("transform", "translateX(0)")

	$(elms.submit).on("click", goToLogin);
	$(elms.btnSnackBarClose).on("click", closeSnackbar);
	bdjs.hideLoading();
};
